module.exports = __webpack_public_path__ + "static/media/link1.c2405c15.svg";